/*=========================================================================================
  File Name: moduleIndicatorMutations.js
  Description: Indicator Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Felix MAsa
  
==========================================================================================*/

export default {
	ADD_INDICATOR_ITEM(state, indicator) {
		state.indicators.unshift(indicator);
	},
	SET_INDICATORS(state, indicators) {
		state.indicators = indicators;
	},
	UPDATE_INDICATOR(state, indicator) {
		const indicatorIndex = state.indicators.findIndex((i) => i.id === indicator.id);
		Object.assign(state.indicators[indicatorIndex], indicator);
	},
	REMOVE_INDICATOR_ITEM(state, itemId) {
		const ItemIndex = state.indicators.findIndex((i) => i.id === itemId);
		state.indicators.splice(ItemIndex, 1);
	},
};
